import { RootState } from 'store';
import { IRejectedDataResponse } from 'types';

export const getRejectedDataSelector = (store: RootState): IRejectedDataResponse | null => store.rejectedData.data || null;

export const getRejectedDataIsLoadingSelector = (store: RootState): boolean => store.rejectedData.isLoading;
